import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService, Core2Config } from '../../../shared';
import { PredefinedMessagePlaceholderContainer } from '../../../../../../../models/mongodbSchema/aggregates';

@Injectable({ providedIn: 'root' })
export class PredefinedMessagePlaceholderService extends BaseApiTemplateService<PredefinedMessagePlaceholderContainer> {
  constructor(private http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'predefined-message-placeholder';
    this.httpClient = http;
  }
}
